module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="note"><header class="header-wrap"><h5 class="module-title">'+
((__t=( i18n.tc( "ControlNote", "Note" ) ))==null?'':__t)+
'</h5><button class="icon icon-material icon-edit transparent" @click="editText()"></button></header><fieldset><p v-if="model.notes">{{ model.notes }}</p><p v-if="model.notes === \'\' "><small>'+
((__t=( i18n.tc( "ControlNote", "No notes" ) ))==null?'':__t)+
'</small></p></fieldset></div>';
}
return __p;
};
